import { Box, Divider, Typography } from '@mui/material';
import { get } from 'lodash';
import React, { FC } from 'react';
import SummaryLine from '../../../../../../../components/ui-component/form-component/abschluss-page/SummaryLine';
import { useApplication } from '../../../../../../../context/ApplicationContext';
import { ABSCHLUSS_SEITE_HEADEING_DESCRIPTION, KOSTEN_ARTEN } from '../../../../../../../lib/constants/constant';
import { DisplayDate, DisplayEuro } from '../../../../../../../utils/formats';
import { enumT } from '../../../../../../../utils/helper';
import AbschlussSeiteBox from '../../../../antrag-components/AbschlussSeiteBox';
import ApplicationHeading from '../../../../application-heading/ApplicationHeading';

// import schemas
import AntragSchema from '../../../../../../../lib/paths/antrag_FULL_Paths.json';
import KostenPositionSchema from '../../../../../../../lib/paths/kostenposition_FULL_Paths.json';

const P = AntragSchema.attributes;
const KP_P = KostenPositionSchema.attributes;

const AbschlussAntrag: FC<{}> = () => {
	const { application } = useApplication();
	const groupedData: Record<string, { foerderprogramm: string; summe: number }> = getFoerderSumme(application);

	return (
		<>
			<ApplicationHeading title='Abschluss' description={ABSCHLUSS_SEITE_HEADEING_DESCRIPTION} />
			<Typography> Projektdaten</Typography> <Divider />
			<AbschlussSeiteBox>
				<SummaryLine
					label='Datum der Einreichung:'
					value={
						get(application, P.Zusammenfassung_Ueberblick_Datum_Der_Bewilligung.path) ?
							DisplayDate(get(application, P.Zusammenfassung_Ueberblick_Datum_Der_Bewilligung.path))
							: 'Noch nicht eingereicht'
					}
				/>
				<SummaryLine label='MKS:' value={get(application, P.MKS.schema.attributes.Geschaeftsbezogene_Daten_Name_Der_Organisation.path, '')} />
				<SummaryLine label='Antragstitel:' value={get(application, P.Zusammenfassung_Ueberblick_Titel.path, '')} />
				<SummaryLine label='Status:' value={enumT(get(application, P.Status_Status.path))} />

				<SummaryLine label='Laufzeit von:' value={DisplayDate(get(application, P.Zusammenfassung_Ueberblick_Laufzeit_Von.path))} />
				<SummaryLine label='Laufzeit bis:' value={DisplayDate(get(application, P.Zusammenfassung_Ueberblick_Laufzeit_Bis.path))} />
					{Object.entries(groupedData).map(([groupKey, value]) => (
						<SummaryLine key={groupKey} label={value.foerderprogramm} value={DisplayEuro(value.summe)} />
					))}

				<SummaryLine
					label='Beantragte Fördersumme:'
					value={DisplayEuro(get(application, P.Zusammenfassung_Ueberblick_beantragte_Foerdersumme.path, 0))}
				/>

				{get(application, P.Zusammenfassung_Ueberblick_bewilligte_Foerdersumme.path) && (
					<Box sx={{ mt: '2rem' }}>
						<Typography> Bewilligte Daten</Typography>
						<Divider />
						<SummaryLine
							label='Bewilligte Fördersumme:'
							value={DisplayEuro(get(application, P.Zusammenfassung_Ueberblick_bewilligte_Foerdersumme.path, 0))}
						/>
						<SummaryLine
							label='Auszuzahlende Summe 85%:'
							value={DisplayEuro(get(application, P.Zusammenfassung_Ueberblick_auszuzahlende_Summe_85.path, 0))}
						/>
						<SummaryLine label='Einbehalt 15%:' value={DisplayEuro(get(application, P.Zusammenfassung_Ueberblick_Einbehalt_15.path, 0))} />
					</Box>
				)}
			</AbschlussSeiteBox>
		</>
	);
};

const getFoerderSumme = (application: any) => {
	const allKostenPositions = get(application, P.Antrag_Kostenpositions.path, []);
	const groupedData = allKostenPositions.reduce((acc: any, item: any) => {
		const key = get(item, KP_P.Allgemein_Gruppierung_ID.path, '').trim();
		if (get(item, KP_P.Allgemein_Kostenart.path, '') === KOSTEN_ARTEN.Personalkosten) {
			if (key) {
				if (!acc[key]) {
					acc[key] = [];
				}
				acc[key].push(item);
			}
		}
		return acc;
	}, {});

	let foerderSumme: any = {};
	Object.keys(groupedData).forEach((key) => {
		const summe = groupedData[key].reduce(
			(total: number, item: any) =>
				total + (get(item, KP_P.Beantragte_Foerderung_beantragte_Foerderung.path, 0) || 0),
			0
		);
		const fp = get(groupedData[key][0], KP_P.Allgemein_Foerderprogramm.schema.attributes.Allgemein_Titel.path, '');
		foerderSumme[key] = { foerderprogramm: fp, summe };
	});
	return foerderSumme;
};


export default AbschlussAntrag;
